"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_85_1_0 = void 0;
/**
 * remove DeleteCL, IARules
 * rename SmartPlasticsEcwAllowed to SmartPlasticsECWAllowed
 */
const migration_85_1_0 = (json) => {
    if (json.Kette) {
        if (json.Kette.DeltaCL) {
            delete json.Kette.DeltaCL;
        }
        if (json.Kette.IARules) {
            delete json.Kette.IARules;
        }
        if (json.Kette.SmartPlasticsEcwAllowed) {
            json.Kette.SmartPlasticsECWAllowed = json.Kette.SmartPlasticsEcwAllowed;
            delete json.Kette.SmartPlasticsEcwAllowed;
        }
    }
    return json;
};
exports.migration_85_1_0 = migration_85_1_0;
//# sourceMappingURL=migration_85_1_0.js.map